import { useId, useState, type ReactNode } from 'react'
import { AreaDeTexto } from '@ui/primitivas/AreaDeTexto'
import { Boton } from '@ui/primitivas/Boton'

/** Bloque numerado dentro de una etapa (p. ej. «2.1 Valida las tareas»). */
export function Subpaso(props: { numero: string; titulo: string; detalle?: ReactNode; activo?: boolean; acciones?: ReactNode; children?: ReactNode; etiqueta?: string }) {
  const id = useId()
  return (
    <section className="sst-subpaso" data-activo={props.activo ? 'true' : undefined} aria-labelledby={id} data-paso={props.numero}>
      <div className="sst-subpaso-cabecera">
        <div className="sst-subpaso-titulo">
          <span className="sst-subpaso-numero" aria-hidden="true">{props.numero}</span>
          <div>
            <h3 id={id}><span className="sr-only">Paso {props.numero}: </span>{props.titulo}</h3>
            {props.detalle ? <p>{props.detalle}</p> : null}
          </div>
        </div>
        {props.acciones ? <div className="flex flex-wrap items-center gap-2">{props.acciones}</div> : null}
      </div>
      {props.children}
    </section>
  )
}

/**
 * Confirmación de descarte en línea: reemplaza el diálogo del navegador. El motivo es opcional
 * y el descarte es reversible (el elemento queda en «descartadas» y se puede recuperar).
 */
export function ConfirmacionDeDescarte(props: { que: string; trabajando?: boolean; alConfirmar: (motivo: string | undefined) => void; alCancelar: () => void }) {
  const [motivo, setMotivo] = useState('')
  return (
    <div className="sst-descarte" role="group" aria-label={`Descartar ${props.que}`}>
      <p className="font-semibold">¿Descartar {props.que}?</p>
      <p className="text-pequeno text-texto-secundario">Quedará en la lista de descartadas y podrás recuperarla. No se incluye en la matriz oficial.</p>
      <AreaDeTexto etiqueta="Motivo del descarte (opcional)" valor={motivo} alCambiar={setMotivo} filas={2} marcador="Ej.: la tarea no se realiza en este centro" />
      <div className="flex flex-wrap justify-end gap-2">
        <Boton variante="secundario" compacto alPulsar={props.alCancelar}>Cancelar</Boton>
        <Boton variante="peligro" compacto trabajando={props.trabajando ?? false} alPulsar={() => props.alConfirmar(motivo.trim() || undefined)}>Confirmar descarte</Boton>
      </div>
    </div>
  )
}
